/* Bazan 2026 — CTA banner: ATC qua theme.AjaxProduct để mở cart drawer
   thay vì redirect sang /cart. Cùng pattern với bz-product.js. */
function initBzCtaAjaxCart() {
  var forms = document.querySelectorAll('.bz-cta__form');
  if (!forms.length) return;

  // Đợi theme.AjaxProduct sẵn sàng
  if (typeof theme === 'undefined' || !theme.AjaxProduct) {
    setTimeout(initBzCtaAjaxCart, 200);
    return;
  }

  forms.forEach(function(form) {
    if (form.dataset.bzCtaAjax) return; // tránh init 2 lần (theme editor reload)
    form.dataset.bzCtaAjax = 'true';
    new theme.AjaxProduct(form, '.bz-cta__atc');

    // Seal Subscriptions chèn widget + input selling_plan vào mọi form cart/add.
    // Form CTA chỉ mua 1 lần -> xoá widget và selling_plan mỗi khi app inject.
    var stripSeal = function() {
      form.querySelectorAll('.sealsubs-target-element, .sealsubs-container, input[name="selling_plan"]')
        .forEach(function(el) { el.remove(); });
    };
    stripSeal();
    new MutationObserver(stripSeal).observe(form, { childList: true, subtree: true });
  });
}

/* Trang product: click CTA -> bấm hộ nút ATC chính của buy box (nếu có) để add
   ĐÚNG cấu hình khách đã chọn ở trên (variant + One-Time/Subscribe + kỳ hạn;
   form chính có input selling_plan do Seal quản lý) — giống cách sticky ATC làm.
   Trang không có buy box -> fallback: copy variant id rồi submit form CTA như cũ. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('.bz-cta__atc');
  if (!btn) return;
  var mainBtn = document.querySelector('[data-bz-product] [data-bz-atc]');
  if (mainBtn) {
    e.preventDefault();
    mainBtn.click();
    return;
  }
  var form = btn.closest('.bz-cta__form');
  if (!form) return;
  var src = document.querySelector('[data-bz-variant-id]');
  var dst = form.querySelector('input[name="id"]');
  if (src && dst && src.value) dst.value = src.value;
}, true);

/* Label CTA đồng bộ theo lựa chọn Seal ở buy box:
   One-Time -> "Buy Once - $x" | Subscribe -> "Subscribe - <kỳ hạn> - $y".
   Giá đọc từ .sls-price của card đang active (đã format + currency app);
   kỳ hạn = option đang chọn của select[name="subs_interval"] (nguồn mà
   bz-sticky__freq copy). Không có buy box/Seal -> giữ nguyên text setting. */
function initBzCtaSealSync() {
  var btn = document.querySelector('.bz-cta__atc');
  var root = document.querySelector('[data-bz-product]');
  if (!btn || !root) return;
  var sub = root.querySelector('.bz-product__subscribe');
  if (!sub) return;

  function update() {
    var all = [].slice.call(sub.querySelectorAll('.sls-option-container'));
    var active = sub.querySelector('.sls-option-container.sls-active');
    if (!all.length || !active) return;
    var isSubscribe = all.indexOf(active) === 1;
    var priceEl = active.querySelector('.sls-price');
    var price = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var txt;
    if (isSubscribe) {
      var freq = sub.querySelector('select[name="subs_interval"]');
      var freqTxt = freq && freq.selectedIndex >= 0 ? freq.options[freq.selectedIndex].text.trim() : '';
      txt = 'Subscribe' + (freqTxt ? ' - ' + freqTxt : '') + (price ? ' - ' + price : '');
    } else {
      txt = 'Buy Once' + (price ? ' - ' + price : '');
    }
    if (btn.textContent.trim() !== txt) btn.textContent = txt;
  }

  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    if (sub.querySelectorAll('.sls-option-container').length) {
      clearInterval(poll);
      update();
      // Seal đổi active card / giá / kỳ hạn (kể cả khi đổi variant) -> update label.
      new MutationObserver(update).observe(sub, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['class']
      });
      var freq = sub.querySelector('select[name="subs_interval"]');
      if (freq) freq.addEventListener('change', function () { setTimeout(update, 0); });
    } else if (tries > 50) {
      clearInterval(poll);
    }
  }, 200);
}

function bootBzCta() {
  initBzCtaAjaxCart();
  initBzCtaSealSync();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootBzCta);
} else {
  bootBzCta();
}
